import parseStringAsHtml from '@naturehouse/nh-essentials/lib/html/parser';

export default function tableTemplate(): HTMLTemplateElement {
    return parseStringAsHtml(`
        <template>
            <thead><tr data-role="row-table-head"></tr></thead>
            <tbody data-role="table-body"></tbody>
        </template>
     `) as HTMLTemplateElement;
}

export function renderTableHead(column: TableColumn): HTMLTableSectionElement {
    const tableHeadElement: HTMLTableSectionElement = document.createElement(
        'TH'
    ) as HTMLTableSectionElement;

    if (column.noWrap) {
        tableHeadElement.classList.add('no-wrap');
    }

    if (column.url) {
        const anchor = document.createElement('A') as HTMLAnchorElement;
        anchor.href = column.url;
        anchor.innerText = column.title;
        tableHeadElement.dataset.sort = column.sort;
        tableHeadElement.appendChild(anchor);
    } else {
        tableHeadElement.innerText = column.title;
    }

    return tableHeadElement;
}

export function renderTableRow(
    rowData: StandardObjectInterface,
    columnIds: (string | ((column: StandardObjectInterface) => string))[]
): HTMLTableSectionElement {
    const tableRowElement = document.createElement('TR') as HTMLTableSectionElement;
    columnIds.forEach((columnId: string | ((id: StandardObjectInterface) => string)) => {
        const tableCellElement = document.createElement('TD');
        if (typeof columnId === 'string') {
            tableCellElement.innerText = rowData[columnId];
        } else {
            tableCellElement.innerHTML = columnId(rowData);
        }

        tableRowElement.append(tableCellElement);
    });

    return tableRowElement;
}
